// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_X-Y","cls2":"ProfilePdfPackCard-cls2_YN4 ProfilePdfPackCard-cls1_X-Y"};